<template>
  <div class="padded vh100 flex-center">
    <form id="register-view" class="card form form_login padded-xl w500" @submit.prevent="doregister">
      <!--img src="https://www.persona.agency/api/logo.svg" alt="" class="main-logo"/-->
      <h1 class="title title_1">Bedenk een wachtwoord</h1>
      <transition name="fade">
        <alert-bar v-if="msgtext" v-bind:class="msgclass">{{msgtext}}</alert-bar>
      </transition>
      <input-default label="Wat wil je als wachtwoord?" v-model="password" description="Kies minimaal 6 letters en 2 getallen"/>
      <button class="button button-primary" type="submit">Dit wordt mijn wachtwoord</button>
    </form>
  </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import AlertBar from '../components/form/Alert.vue';

  import { userService } from '../services/user.service.js';

  export default {
    data: function (){
      return {
        msgtext: '',
        msgclass: 'error',
        password: '',
        returnUrl: '',
        error: ''
      }
    },
    components: {
      InputDefault,
      AlertBar
    },
    methods: {
      doregister: function (event) {

        userService.login()
        .then(
          user => this.$router.push(this.returnUrl),
          error => {
            this.msgtext = error;
            this.loading = false;
          }
        );
      }
    }
  }
</script>